// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 프로그램관리 화면 */

.mm-wrap {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  gap: 10px;
}

/* ── 상단 툴바 ── */
.mm-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 6px 0 0;
}

/* ── 테이블 컨테이너 ── */
.mm-table-wrap {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
  border: 1px solid #dde2ef;
  border-radius: 6px;
  background: #fff;
}

.mm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;
}

.mm-table th {
  padding: 7px 10px;
  background: #f4f6fa;
  border-bottom: 2px solid #dde2ef;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  position: sticky;
  top: 0;
  z-index: 1;
  white-space: nowrap;
  overflow: hidden;
}

.mm-table td {
  padding: 5px 10px;
  border-bottom: 1px solid #f2f2f2;
  color: #333;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mm-table tr:hover td { background: #fafbff; }
.mm-table tr.mm-row-new td { background: #fffbf0; }
.mm-table tr.mm-row-new:hover td { background: #fff4d0; }

/* 컬럼 너비 */
.mm-col-code   { width: 120px; }
.mm-col-name   { width: 160px; }
.mm-col-grp    { width: 120px; }
.mm-col-grpnm  { width: 100px; }
.mm-col-sort   { width: 70px; text-align: right !important; }
.mm-col-admin  { width: 80px; text-align: center !important; }
.mm-col-active { width: 80px; text-align: center !important; }
.mm-col-date   { width: 140px; }
.mm-col-action { width: 100px; text-align: center !important; }

.mm-td-sort   { text-align: right; }
.mm-td-center { text-align: center; }

/* ── 인라인 편집 입력 ── */
.mm-input {
  width: 100%;
  box-sizing: border-box;
  padding: 3px 6px;
  border: 1px solid #4a90e2;
  border-radius: 3px;
  font-size: 12px;
  background: #fff;
}
.mm-input:focus { outline: none; }
.mm-input-sm { width: 60px; }

.mm-select {
  padding: 3px 4px;
  border: 1px solid #4a90e2;
  border-radius: 3px;
  font-size: 12px;
  background: #fff;
}
.mm-select:focus { outline: none; }

/* ── 뱃지 ── */
.mm-badge-admin  { font-size: 10px; background: #4a90e2; color: #fff; padding: 2px 6px; border-radius: 3px; }
.mm-badge-user   { font-size: 10px; background: #eee; color: #555; padding: 2px 6px; border-radius: 3px; }
.mm-badge-active { font-size: 10px; background: #e6f9f0; color: #1a9052; padding: 2px 6px; border-radius: 3px; }
.mm-badge-off    { font-size: 10px; background: #f0f0f0; color: #999; padding: 2px 6px; border-radius: 3px; }

/* ── 버튼 ── */
.btn { border-radius: 4px; cursor: pointer; font-size: 12px; }
.btn-sm { padding: 4px 10px; }
.btn-primary  { background: #1a1a2e; color: #fff; border: none; }
.btn-primary:hover:not(:disabled) { background: #16213e; }
.btn-primary:disabled { background: #999; cursor: not-allowed; }
.btn-outline  { background: #fff; color: #333; border: 1px solid #bbb; }
.btn-outline:hover:not(:disabled) { background: #f0f0f0; }
.btn-outline:disabled { opacity: 0.5; cursor: not-allowed; }
.btn-danger   { background: #e74c3c; color: #fff; border: none; }
.btn-danger:hover:not(:disabled)  { background: #c0392b; }
.btn-danger:disabled  { background: #999; cursor: not-allowed; }
.btn-link     { background: none; border: none; color: #4a90e2; cursor: pointer; font-size: 12px; padding: 0; }
.btn-link:hover { text-decoration: underline; }

/* ── 빈 상태 ── */
.mm-empty {
  text-align: center;
  padding: 32px;
  color: #aaa;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/MenuMasterPage.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,wBAAwB,mBAAmB,EAAE;AAC7C,6BAA6B,mBAAmB,EAAE;AAClD,mCAAmC,mBAAmB,EAAE;;AAExD,UAAU;AACV,iBAAiB,YAAY,EAAE;AAC/B,iBAAiB,YAAY,EAAE;AAC/B,iBAAiB,YAAY,EAAE;AAC/B,iBAAiB,YAAY,EAAE;AAC/B,iBAAiB,WAAW,EAAE,4BAA4B,EAAE;AAC5D,iBAAiB,WAAW,EAAE,6BAA6B,EAAE;AAC7D,iBAAiB,WAAW,EAAE,6BAA6B,EAAE;AAC7D,iBAAiB,YAAY,EAAE;AAC/B,iBAAiB,YAAY,EAAE,6BAA6B,EAAE;;AAE9D,gBAAgB,iBAAiB,EAAE;AACnC,gBAAgB,kBAAkB,EAAE;;AAEpC,oBAAoB;AACpB;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA,kBAAkB,aAAa,EAAE;AACjC,eAAe,WAAW,EAAE;;AAE5B;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA,mBAAmB,aAAa,EAAE;;AAElC,aAAa;AACb,mBAAmB,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC5G,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACzG,mBAAmB,eAAe,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC/G,mBAAmB,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAE5G,aAAa;AACb,OAAO,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC7D,UAAU,iBAAiB,EAAE;AAC7B,gBAAgB,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE;AAChE,oCAAoC,mBAAmB,EAAE;AACzD,wBAAwB,gBAAgB,EAAE,mBAAmB,EAAE;AAC/D,gBAAgB,gBAAgB,EAAE,WAAW,EAAE,sBAAsB,EAAE;AACvE,oCAAoC,mBAAmB,EAAE;AACzD,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;AAC3D,gBAAgB,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE;AAChE,oCAAoC,mBAAmB,EAAE;AACzD,wBAAwB,gBAAgB,EAAE,mBAAmB,EAAE;AAC/D,gBAAgB,gBAAgB,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,UAAU,EAAE;AAC9G,kBAAkB,0BAA0B,EAAE;;AAE9C,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* 프로그램관리 화면 */\n\n.mm-wrap {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  gap: 10px;\n}\n\n/* ── 상단 툴바 ── */\n.mm-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  padding: 6px 0 0;\n}\n\n/* ── 테이블 컨테이너 ── */\n.mm-table-wrap {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  border: 1px solid #dde2ef;\n  border-radius: 6px;\n  background: #fff;\n}\n\n.mm-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  table-layout: fixed;\n}\n\n.mm-table th {\n  padding: 7px 10px;\n  background: #f4f6fa;\n  border-bottom: 2px solid #dde2ef;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.mm-table td {\n  padding: 5px 10px;\n  border-bottom: 1px solid #f2f2f2;\n  color: #333;\n  vertical-align: middle;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mm-table tr:hover td { background: #fafbff; }\n.mm-table tr.mm-row-new td { background: #fffbf0; }\n.mm-table tr.mm-row-new:hover td { background: #fff4d0; }\n\n/* 컬럼 너비 */\n.mm-col-code   { width: 120px; }\n.mm-col-name   { width: 160px; }\n.mm-col-grp    { width: 120px; }\n.mm-col-grpnm  { width: 100px; }\n.mm-col-sort   { width: 70px; text-align: right !important; }\n.mm-col-admin  { width: 80px; text-align: center !important; }\n.mm-col-active { width: 80px; text-align: center !important; }\n.mm-col-date   { width: 140px; }\n.mm-col-action { width: 100px; text-align: center !important; }\n\n.mm-td-sort   { text-align: right; }\n.mm-td-center { text-align: center; }\n\n/* ── 인라인 편집 입력 ── */\n.mm-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 3px 6px;\n  border: 1px solid #4a90e2;\n  border-radius: 3px;\n  font-size: 12px;\n  background: #fff;\n}\n.mm-input:focus { outline: none; }\n.mm-input-sm { width: 60px; }\n\n.mm-select {\n  padding: 3px 4px;\n  border: 1px solid #4a90e2;\n  border-radius: 3px;\n  font-size: 12px;\n  background: #fff;\n}\n.mm-select:focus { outline: none; }\n\n/* ── 뱃지 ── */\n.mm-badge-admin  { font-size: 10px; background: #4a90e2; color: #fff; padding: 2px 6px; border-radius: 3px; }\n.mm-badge-user   { font-size: 10px; background: #eee; color: #555; padding: 2px 6px; border-radius: 3px; }\n.mm-badge-active { font-size: 10px; background: #e6f9f0; color: #1a9052; padding: 2px 6px; border-radius: 3px; }\n.mm-badge-off    { font-size: 10px; background: #f0f0f0; color: #999; padding: 2px 6px; border-radius: 3px; }\n\n/* ── 버튼 ── */\n.btn { border-radius: 4px; cursor: pointer; font-size: 12px; }\n.btn-sm { padding: 4px 10px; }\n.btn-primary  { background: #1a1a2e; color: #fff; border: none; }\n.btn-primary:hover:not(:disabled) { background: #16213e; }\n.btn-primary:disabled { background: #999; cursor: not-allowed; }\n.btn-outline  { background: #fff; color: #333; border: 1px solid #bbb; }\n.btn-outline:hover:not(:disabled) { background: #f0f0f0; }\n.btn-outline:disabled { opacity: 0.5; cursor: not-allowed; }\n.btn-danger   { background: #e74c3c; color: #fff; border: none; }\n.btn-danger:hover:not(:disabled)  { background: #c0392b; }\n.btn-danger:disabled  { background: #999; cursor: not-allowed; }\n.btn-link     { background: none; border: none; color: #4a90e2; cursor: pointer; font-size: 12px; padding: 0; }\n.btn-link:hover { text-decoration: underline; }\n\n/* ── 빈 상태 ── */\n.mm-empty {\n  text-align: center;\n  padding: 32px;\n  color: #aaa;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
